"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
const roles = __importStar(require("../core/constants/Roles"));
// @ts-ignore
const c = __importStar(require("../core/constants/ReportStatus"));
// @ts-ignore
const Storage_1 = __importDefault(require("./Storage"));
//this is singleton class which loads role and userID one time in project and refresh it by new login
class User {
    constructor() {
    }
    static userRole(refresh = false) {
        if (refresh || !this.role) {
            this.role = Storage_1.default.getRoles();
        }
        return this.role;
    }
    static userID(refresh = false) {
        if (refresh || !this.user_id) {
            this.user_id = Storage_1.default.getUserID();
        }
        return this.user_id;
    }
    static UserIsPublic(refresh = false) {
        if (refresh || !this.isPublic) {
            this.isPublic = Storage_1.default.getIsPublic();
        }
        return this.isPublic;
    }
    static UserIsGuest(refresh = false) {
        if (refresh || !this.isGuest) {
            this.isGuest = this.role === roles.ROLE_GUEST;
        }
        return this.isGuest;
    }
    static refreshUser() {
        this.userRole(true);
        this.userID(true);
        this.UserIsPublic(true);
        this.UserIsGuest(true);
    }
    static hasRole(role) {
        let result = (this.userRole() & role) === role;
        // if (result && !includeAdmin && role === ROLE_ADMIN) {
        if (result && role === roles.ROLE_ADMIN) {
            result = false;
        }
        return result;
    }
    static hasAnyRole(roles) {
        for (let role of roles) {
            if (this.hasRole(role)) {
                return true;
            }
        }
        return false;
    }
    static isBelongsToReport(report) {
        let peopleIds = [report.typist_id, report.reporter_id, report.verifier_id, report.resident2_id, report.verifier2_id];
        return peopleIds.indexOf(this.userID()) >= 0;
    }
    static isTypist() {
        return this.hasRole(roles.ROLE_TYPIST);
    }
    static isAdmin() {
        return (this.userRole() & roles.ROLE_ADMIN) === roles.ROLE_ADMIN;
    }
    static isAssistant() {
        return this.hasRole(roles.ROLE_ASSISTANT);
    }
    static isStaff() {
        return this.hasRole(roles.ROLE_STAFF);
    }
    static isAccount() {
        return this.hasRole(roles.ROLE_ACCOUNT);
    }
    static canReport() {
        return this.hasAnyRole([roles.ROLE_TYPIST, roles.ROLE_RESIDENT, roles.ROLE_STAFF]);
    }
    static canEditReport(report) {
        return report && report['can_edit'];
    }
    static canPrintReport(report) {
        return report && report['can_print'];
    }
    static canViewPrintReportButton(report) {
        return report && report['can_print'] && (this.isTypist() || this.isAccount());
    }
    static canSendToHISReport(report) {
        return report && report['can_send_to_his'];
    }
    static canAcceptReport(report) {
        return report && report.status <= c.REPORT_STATUS_TYPED && (this.isStaff() || this.isAssistant()) && this.isBelongsToReport(report);
    }
    static canVerifyReport(report) {
        return report && (report.status <= c.REPORT_STATUS_ACCEPTED) && this.isStaff() && this.isBelongsToReport(report);
    }
    static canVerifyWithStaffReport(report) {
        return report && (report.status === c.REPORT_STATUS_ACCEPTED) && this.isAssistant() && this.isBelongsToReport(report);
    }
    static canVerifyWithoutStaffReport(report) {
        return report && (report.status === c.REPORT_STATUS_ACCEPTED) && this.isAssistant() && this.isBelongsToReport(report);
    }
    static canViewStudyFilter() {
        return !(this.UserIsGuest() || this.UserIsPublic());
    }
    static canViewUserSettingMenu() {
        return !(this.UserIsGuest() || this.UserIsPublic());
    }
    static canViewHeaderSettings() {
        return !(this.UserIsGuest() || this.UserIsPublic());
    }
    static canViewAddPatientButton(device) {
        return this.isAdmin() || (device === "desktop" && this.hasAnyRole([roles.ROLE_STAFF, roles.ROLE_RESIDENT, roles.ROLE_TYPIST]));
    }
}
exports.default = User;
